import { PayrollReportSummaryDTO } from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';
import { PayrollReportCreationProcessData } from 'src/app/shared/constants-and-enums/payroll-report-creation-process-types';

export const InitPayrollReportCreationForm = createAction('[PayrollReportCreationProcess] InitPayrollReportCreationForm');
export const ResetPayrollReportCreationForm = createAction('[PayrollReportCreationProcess] ResetPayrollReportCreationForm');
export const PayrollReportCreationProcessUpsertForm = createAction(
    '[PayrollReportCreationProcess] PayrollReportCreationProcessUpsertForm',
    props<{ data: PayrollReportCreationProcessData }>()
);

export const StartPayrollReportCreationProcess = createAction('[PayrollReportCreationProcess] StartPayrollReportCreationProcess');
export const PayrollReportCreationProcessSuccess = createAction(
    '[PayrollReportCreationProcess] PayrollReportCreationProcessSuccess',
    props<{ results: PayrollReportSummaryDTO[] }>()
);
export const PayrollReportCreationProcessFailure = createAction(
    '[PayrollReportCreationProcess] PayrollReportCreationProcessFailure',
    props<{ error?: any }>()
);
